import {
    RxJsonSchema
} from 'rxdb';
import { Building } from '../models/building';

export const buildingSchema: RxJsonSchema<Building> = {
    title: 'building schema',
    //description: 'describes a simple hero',
    version: 1,
    keyCompression: false,
    type: 'object',
    properties: {
        id: {
            type: 'string',
            primary: true
        },
        market: { type: ['string', 'null'] },
        morphology: { type: ['string', 'null'] },
        useCategory: { type: ['string', 'null'] },
        category: { type: ['string', 'null'] },
        characteristics: { type: ['string', 'null'] },
        commonName: { type: ['string', 'null'] },
        civicAddress: { type: ['string', 'null'] },
        civicLatitude: { type: ['number', 'null'] },
        civicLongitude: { type: ['number', 'null'] },
        contactName: { type: ['string', 'null'] },
        contactNumber: { type: ['string', 'null'] },
        contactEmail: { type: ['string', 'null'] },
        construction: { type: ['string', 'null'] },
        updatedAt: { type: 'number' }
    },
    required: ['id' ],
    indexes: [ 'updatedAt']
};

export const buildingPullQueryBuilder = () => {
    return (doc) => {
        if (!doc) {
            doc = {
                id: '',
                market: '',
                morphology: '',
                useCategory: '',
                category: '',
                characteristics: '',
                commonName: '',
                civicAddress: '',
                civicLatitude: 0,
                civicLongitude: 0,
                contactName: '',
                contactNumber: '',
                contactEmail: '',
                construction: '',
                updatedAt: 0,
                deleted: false,
                _rev: ''
            };
        }

        const query = `{
            feedForRxdbBuildings(lastId: "${doc.id}", minUpdatedAt: ${doc.updatedAt}){
                id
                market
                morphology
                useCategory
                category
                characteristics
                commonName
                civicAddress
                civicLatitude
                civicLongitude
                contactName
                contactNumber
                contactEmail
                construction
                updatedAt
                deleted
                _rev
            }
        }`;
        return {
            query,
            variables: {}
        };
    };
};


//Need to have shared schema with server for this to work
export const graphQLGenerationInput = {
    allBuildings: {
        schema: buildingSchema,
        feedKeys: [
            'id',
            'commonname',
            'updatedAt'
        ],
        deletedFlag: 'deleted'
    }
}